// Lib
import { createAction } from '@reduxjs/toolkit';

export const GetHolidays = createAction('GET_HOLIDAYS');
export const SetHolidays = createAction('SET_HOLIDAYS');
